import { FormatNames } from '@anm/api/modules/hosting';
import VIEW_FORMATS from '@anm/data/video-landings/viewFormats';
import capitalize from '@anm/helpers/string/capitalize';
import { useCallback, FC } from 'react';

import { Item, ItemWrapper, ListWrapper, Wrapper } from './Wrapper';

type ViewFormatsProps = {
  onChange: (format: FormatNames) => void;
  isHovered?: boolean;
  selectedItem?: FormatNames;
};

const ViewFormats: FC<ViewFormatsProps> = ({
  onChange,
  isHovered = false,
  selectedItem = 'mobile'
}) => {
  const handleSelectFormat = useCallback(
    (format: FormatNames) => onChange(format),
    []
  );

  return (
    <Wrapper {...{ isHovered }}>
      <ListWrapper>
        {VIEW_FORMATS.map(({ name, iconSrc }) => {
          const isSelected = selectedItem === name;

          const handleItemClick = useCallback(
            () => handleSelectFormat(name),
            []
          );

          return (
            <ItemWrapper
              key={name}
              onClick={handleItemClick}
              {...{ iconSrc, isSelected }}
            >
              <Item>{capitalize(name)}</Item>
            </ItemWrapper>
          );
        })}
      </ListWrapper>
    </Wrapper>
  );
};

export default ViewFormats;
